import { Component, OnInit } from '@angular/core';
import { NavController, AlertController, App, Events, NavParams, LoadingController } from 'ionic-angular';
import { MeteorObservable, ObservableCursor } from 'meteor-rxjs';

import { Company, Project } from 'api/models';
// import { subscribeActiveCompany, subscribeActiveCompanyProjects, getCompany, getCompanyProjects } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { ProjectDetailTabsPage } from '../project-detail-tabs/project-detail-tabs';
import { ProjectHomePage } from '../project-home/project-home';
import { HttpService } from '../../services/httpService';
import { Updates, Users } from 'api/collections';
import { SharedService } from '../../services/sharedService';
import { AuthenticationService } from '../../services/congito';

@Component({
  selector: 'company-projects-tab',
  templateUrl: 'company-projects-tab.html'
})
export class CompanyProjectsTab implements OnInit {
  company?: Company | void;
  projects?: ObservableCursor<Project>;
  interval:any;
  loading=false;
  constructor(
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private events: Events,
    public appCtrl: App,
    public navParams: NavParams,
    public httpService: HttpService,
    private sharedService: SharedService,
    public authenticationService: AuthenticationService,
    public companyService: CompanyService
  ) {
  }

  ngOnInit(): void {
    const companyId = this.navParams.get('companyId');
    MeteorObservable.autorun().subscribe(() => {
      if (companyId) {
        this.company = this.companyService.getCompany(companyId);
        this.projects = this.companyService.getCompanyProjects(this.company);
      } else {
        this.company = this.companyService.subscribeActiveCompany();
        this.projects = this.companyService.subscribeActiveCompanyProjects();
      }
    });
  }

  goToProject(project: Project): void {
    const loader = this.loadingCtrl.create({
      content: "Please wait...",
      enableBackdropDismiss: true,
    });
    loader.present();
      


    this.loading=true;
    this.httpService.MeteorCall('setActiveProject', project._id)
      .then(async () => {
        Users.update({_id: this.authenticationService.MeteorUserId()}, {$set: {"profile.activeProjectId":project._id}});
        this.sharedService.projectChanged.emit(project);
        await this.httpService.MeteorSubscribe('projectDetails', project._id)
        .then(()=>this.httpService.privateLoopAction(true));
        let executions=0;
        
        this.interval=setInterval(()=>{
          executions++;
          if(Updates.findOne({_id:project.currentUpdateId, archived:{$ne:true}})){
            clearInterval(this.interval);
            if(this.loading){
              loader.dismiss()
              this.events.publish('rootNavSetPages', [{ page: ProjectHomePage, params: {projectId:project._id, projectIdReactive:project._id} }]);
            }
          }

          if(executions>50 || !(project && project.currentUpdateId)){
            clearInterval(this.interval);
            loader.dismiss()
            this.events.publish('rootNavSetPages', [{ page: ProjectHomePage, params: {projectId:project._id, projectIdReactive:project._id} }]);
          }


          
        }, 200)


       
      })  
      .catch(err => console.log('meteor call error:', err));
  }

  removeProject(project: Project): void {
    if (!this.company) {
      return;
    }

    let companyId = this.company._id;
    let projectId = project._id;

    const alert = this.alertCtrl.create({
      title: 'Confirm',
      message: `Are you sure you would like to delete this Project?`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Yes',
          handler: () => {
            /*
            MeteorObservable.call('removeCompanyProject', companyId, projectId).subscribe({
              error: (e: Error) => {
                console.error(e);
              }
            });
            */
            this.httpService.MeteorCall(
              'removeCompanyProject',
              companyId,
              projectId
            ).then(() => {})
            .catch((e: Error) => {
              console.error(e);
            });
            alert.dismiss();
            return false;
          }
        }
      ]
    });

    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/company-projects-tab/company-projects-tab.ts